<nz-modal [(nzVisible)]="isVisible" nzTitle="View Driver" (nzOnCancel)="handleCancel()" footer={null}>
  <ng-container *nzModalContent>
    <section id="driverDetails">
      <div class="mt-3">
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Segment</p>
            <p
              class="subject-data">{{(driverData?.driverSegment === "OUTSOURCE_DRIVER") ? 'Outsourced Driver' : 'SR Driver'}}</p>
          </div>
          <div *ngIf="driverData?.driverSegment === 'OUTSOURCE_DRIVER'" class="item-row">
            <p class="subject-name">Supplier </p>
            <p class="subject-data">{{driverData?.supplierName}}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Can Drive </p>
            <div>
              <div>
                <p *ngFor="let can of driverData?.canDrive"
                   class="subject-data">{{can.checked && can.label === "Light Vehicles" ? 'Light Vehicles' : (can.checked && can.label === "Heavy Vehicles" ? 'Heavy Vehicles' : '')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Name </p>
            <p class="subject-data">{{driverData?.fullName}}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">NIC </p>
            <p class="subject-data">{{driverData?.nicNo}}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Mobile Number </p>
            <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="{{driverData?.mobileNumber}}">{{driverData?.mobileNumber}}</a></p>
          </div>
          <div class="item-row">
            <p class="subject-name">Email </p>
            <p class="subject-data clickable-mail-phone_no"><a class="{{driverData?.email}}" href="{{driverData?.email}}">{{driverData?.email}}</a></p>
          </div>
          <div class="item-row">
            <p class="subject-name">Registered/ Unregistered </p>
            <p class="subject-data">{{driverData?.isRegistered ? 'Registered' : 'Unregistered'}}</p>
          </div>
        </div>
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Last Transfer Date and Time </p>
            <p class="subject-data">To do</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Last Transfer Completed Date and Time </p>
            <p class="subject-data">To do</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Next Transfer Allocated Date and Time </p>
            <p class="subject-data">To do</p>
          </div>
        </div>
      </div>
      <h5 class="pt-2">Language and License Information</h5>
      <div class="mt-5 gap-8">
        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Languages</p>
            <div>
              <div class="flex mb-1" *ngFor="let lan of driverData?.languageSkills">
                <p class="subject-data">{{lan.language | titlecase}}
                  - {{lan.level | titlecase}}</p> <br>
              </div>
            </div>
          </div>
          <!--          <div class="grid grid-cols-2 gap-auto">-->
          <!--            <div>-->
          <!--              <p class="font-normal" style="color: #6d6d6d">Registration Number </p>-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              <p class="font-medium">Kasun Rajitha</p>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>

        <div class="sub-section">
          <div class="item-row">
            <p class="subject-name">Driver License Expiry Date </p>
            <p
              class="subject-data">{{driverData?.licenseDetails?.drivingLicenseExpiryDate | date: "dd-MM-y"}}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Tourist Driver License </p>
            <p
              class="subject-data">{{driverData?.licenseDetails?.hasTourDriverLicense ? (driverData?.licenseDetails?.tourDriverLicenseExpiryDate | date: 'dd-MM-y') : '-'}}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">Chauffeur Guide License </p>
            <p
              class="subject-data">{{driverData?.licenseDetails?.hasChauffeurGuideLicense ? (driverData?.licenseDetails?.chauffeurGuideLicenseExpiryDate | date: 'dd-MM-y') : '-'}}</p>
          </div>
          <div class="item-row">
            <p class="subject-name">National Guide License </p>
            <p
              class="subject-data">{{driverData?.licenseDetails?.hasNationalGuideLicense ? (driverData?.licenseDetails?.nationalGuideLicenseExpiryDate | date: 'dd-MM-y') : '-'}}</p>
          </div>
        </div>

        <div class="sub-section">
          <p class="subject-name" style="color: #6d6d6d">Attachments</p>
          <p *ngIf="driverData?.licenseDetails?.attachments.length === 0"
             class="subject-data">-</p>
          <div *ngIf="driverData?.licenseDetails?.attachments.length > 0" class="flex flex-col mt-2">
            <a *ngFor="let file of driverData?.licenseDetails?.attachments" href="{{file.url}}"
               [nz-tooltip]="file.name"
               target="_blank"><span nz-icon nzType="file" class="text-sm"
                                     nzTheme="outline"></span><span
              class="ml-2 text-sm text-black"> - {{file.name}}</span></a>
          </div>
        </div>
      </div>
<!--      <h5 class="pt-2">Payment Details</h5>-->
<!--      <div class="mt-5 gap-8">-->
<!--        <div class="sub-section">-->
<!--          <div class="item-row">-->
<!--            <p class="subject-name">Bank Name</p>-->
<!--            <p class="subject-data">{{driverData?.paymentDetails?.bankName}}</p>-->
<!--          </div>-->
<!--          <div class="item-row">-->
<!--            <p class="subject-name">Branch Name </p>-->
<!--            <p class="subject-data">{{driverData?.paymentDetails?.branchName}}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="sub-section">-->
<!--          <div class="item-row">-->
<!--            <p class="subject-name">Account Type</p>-->
<!--            <p class="subject-data">{{driverData?.paymentDetails?.accountType | titlecase}}</p>-->
<!--          </div>-->
<!--          <div class="item-row">-->
<!--            <p class="subject-name">Account Holder Name </p>-->
<!--            <p class="subject-data">{{driverData?.paymentDetails?.accountHolderName}}</p>-->
<!--          </div>-->
<!--          <div class="item-row">-->
<!--            <p class="subject-name">Account Number </p>-->
<!--            <p class="subject-data">{{driverData?.paymentDetails?.accountNumber}}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="sub-section">-->
<!--          <div class="item-row">-->
<!--            <p class="subject-name">Attachments</p>-->
<!--            <p *ngIf="driverData?.paymentDetails?.attachments.length === 0"-->
<!--               class="subject-data">-</p>-->
<!--            <div *ngIf="driverData?.paymentDetails?.attachments.length > 0" class="flex flex-col mt-2">-->
<!--              <a *ngFor="let file of driverData?.paymentDetails?.attachments" href="{{file.url}}"-->
<!--                 [nz-tooltip]="file.name"-->
<!--                 target="_blank"><span nz-icon nzType="file" class="text-sm"-->
<!--                                       nzTheme="outline"></span><span-->
<!--                class="ml-2 text-sm text-black"> - {{file.name}}</span></a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

    </section>
  </ng-container>
  <ng-container *nzModalFooter>
  </ng-container>
</nz-modal>
